import { PropsWithChildren, FC, createContext, useState, useContext } from 'react';
import noop from 'utils/noop';

type MatchesCatalogContextState = {
  isMatchesCatalogSelected: boolean;
  setIsMatchesCatalogSelected: (newValue: boolean) => void;
};

const defaultMatchesCatalogContextState = {
  isMatchesCatalogSelected: false,
  setIsMatchesCatalogSelected: noop,
};

export const MatchesCatalogContext = createContext<MatchesCatalogContextState>(
  defaultMatchesCatalogContextState,
);

export const useMatchesCatalogContext = () => useContext(MatchesCatalogContext);

export const MatchesCatalogContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [isMatchesCatalogSelected, setIsMatchesCatalogSelected] = useState(false);
  return (
    <MatchesCatalogContext.Provider
      value={{ isMatchesCatalogSelected, setIsMatchesCatalogSelected }}
    >
      {children}
    </MatchesCatalogContext.Provider>
  );
};
